module.exports = __webpack_public_path__ + "static/media/dmod-architects.5cb2cb92.png";